import React from 'react'
import './OnboardingChoiceModal.css'

// Post-name onboarding choice (Phase 3, locked decision #6 in the overview
// doc). Shown once pendingOnboardingChoice is true and hidden the moment any
// of the three exits below is taken. Unlike the name modal, this one is
// dismissible: a parent who dismisses it still reaches legacy
// ParentTutorial / ParentChecklist afterward, and can add a student or open
// the demo later from the checklist, side menu, or Settings.
const OnboardingChoiceModal = ({ onAddStudent, onSeeDemo, onDismiss, busy = false }) => {
  return (
    <div className="qn-onb-overlay" role="presentation">
      <div
        className="qn-onb-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="qn-onb-title"
      >
        <button
          type="button"
          className="qn-onb-close"
          onClick={onDismiss}
          disabled={busy}
          aria-label="Not right now"
          title="Not right now"
        >
          ×
        </button>

        <div className="qn-onb-emoji">🚀</div>
        <h2 id="qn-onb-title" className="qn-onb-title">Ready to get started?</h2>
        <p className="qn-onb-subtitle">
          Add your child as a student, or try a quick interactive demo together first — no account needed for the demo.
        </p>

        <div className="qn-onb-actions">
          <button
            type="button"
            className="qn-onb-btn primary"
            onClick={onAddStudent}
            disabled={busy}
          >
            <span className="qn-onb-btn-emoji" aria-hidden="true">👩‍🎓</span>
            <span className="qn-onb-btn-text">
              <span className="qn-onb-btn-title">Add a student</span>
              <span className="qn-onb-btn-desc">Create your child's profile now</span>
            </span>
          </button>

          <button
            type="button"
            className="qn-onb-btn secondary"
            onClick={onSeeDemo}
            disabled={busy}
          >
            <span className="qn-onb-btn-emoji" aria-hidden="true">🎬</span>
            <span className="qn-onb-btn-text">
              <span className="qn-onb-btn-title">See a demo</span>
              <span className="qn-onb-btn-desc">Try Explain &amp; Check Answer together</span>
            </span>
          </button>
        </div>

        <p className="qn-onb-hint">
          You can always do either one later from your dashboard.
        </p>
      </div>
    </div>
  )
}

export default OnboardingChoiceModal
